import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useMutation } from "@apollo/client";
//icons
import { BiMinusCircle } from "react-icons/bi";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_SUPPLIER } from "../../Schema/Supplier";
import { translateLauguage } from "../../Function/Translate";
import CropImageFile from "../CropImage/CropImageFile";
// import { SelectEmployee } from "../Include/DynamicSelect";
import { UPDATE_EXPENSE_GROUP } from "../../Schema/ExpenseGroup";

export default function CreateSupplier({ open, handleClose, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const EnumBackAccName = [
    "ABA",
    "ACLEDA",
    "LY_HOUR",
    "Cathay_United",
    "Maybank",
    "Sathapana",
    "HRB",
    "Woori",
    "ARDB",
    "Asia_Pacific",
    "Bridge_Specialized",
    "CPB",
    "Canadia",
    "Chip_Mong",
    "Prince",
    "UCB",
    "Vattanac",
    "Wing",
    "AEON",
    "LOLC",
    "CIMB",
    "DGB",
    "Hattha",
    "J_Trust_Royal",
    "Kasikorn",
  ];
  const [bankAcc, setBackAcc] = useState([]);

  //======================handle Update Value Bank Accound======================================
  const handleChange = (key, value, fieldName) => {
    const newData = bankAcc.map((item) => {
      if (fieldName === "name" && item.key === key) {
        item.name = value;
      }
      if (fieldName === "accountNumer" && item.key === key) {
        item.accountNumer = value;
      }
      if (fieldName === "remark" && item.key === key) {
        item.remark = value;
      }
      return item;
    });
    setBackAcc([...newData]);
  };
  //======================handle Add Bank Accound======================================
  const handleAddBankAcc = () => {
    setBackAcc([
      { key: Date.now(), name: "ABA", accountNumer: "", remark: "" },
      ...bankAcc,
    ]);
  };
  //======================handle Remove Bank Accound======================================
  const handleDeleteBankAcc = (key) => {
    const newData = bankAcc.filter((item) => item.key !== key);
    setBackAcc([...newData]);
  };
  const [createSupplier] = useMutation(CREATE_SUPPLIER, {
    onCompleted: ({ createSupplier }) => {
      setLoading(false);
      // console.log("createSupplier::", createSupplier);
      if (createSupplier?.status === true) {
        setAlert(true, "success", createSupplier?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createSupplier?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const CreateSupplier = Yup.object().shape({
    name: Yup.string().required("required!"),
    tell: Yup.string(),
    address: Yup.string(),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      tell: "",
      address: "",
      remark: "",
    },
    validationSchema: CreateSupplier,
    onSubmit: async (values) => {
      const dataBankAcc = bankAcc.map((item) => {
        return {
          name: item?.name,
          accountNumer: item?.accountNumer,
          remark: item?.remark,
        };
      });
      // console.log("values", values);
      setLoading(true);
      createSupplier({
        variables: {
          ...values,
          bankAccounts: dataBankAcc,
        },
      });
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    resetForm();
    setBackAcc([]);
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_create_supplier")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  {t("thead_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_name")}
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                  multiline
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Typography className="field-title">
                  {t("thead_telephone")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_telephone")}
                  {...getFieldProps("tell")}
                  multiline
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_address")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_address")}
                  {...getFieldProps("address")}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Stack direction={"row"} alignItems={"center"}>
                  <Typography className="field-title">Bank name</Typography>
                  <Typography
                    className="field-title"
                    sx={{ paddingLeft: "45px" }}
                  >
                    Account number
                  </Typography>
                  <Typography
                    className="field-title"
                    sx={{ paddingLeft: "120px" }}
                  >
                    Remark
                  </Typography>
                  <Box flexGrow={1} />
                  <IconButton onClick={handleAddBankAcc}>
                    <AddCircleOutlineIcon style={{ color: "#0f81c2" }} />
                  </IconButton>
                </Stack>
                <Stack direction={"column"} spacing={2}>
                  {bankAcc.map((item) => {
                    return (
                      <Stack direction={"row"} spacing={1}>
                        <Stack sx={{ width: "20%" }}>
                          <FormControl fullWidth size="small">
                            <Select
                              value={item.name}
                              onChange={(e) => {
                                handleChange(item.key, e.target.value, "name");
                              }}
                            >
                              {EnumBackAccName.map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                        </Stack>
                        <TextField
                          fullWidth
                          size="small"
                          className="text-field"
                          placeholder="bank account number"
                          value={item.accountNumer}
                          sx={{ width: "42%" }}
                          onChange={(e) => {
                            handleChange(
                              item.key,
                              e.target.value,
                              "accountNumer"
                            );
                          }}
                          multiline
                        />
                        <TextField
                          fullWidth
                          size="small"
                          className="text-field"
                          placeholder="remark"
                          value={item.remark}
                          sx={{ width: "25%" }}
                          onChange={(e) => {
                            handleChange(item.key, e.target.value, "remark");
                          }}
                          multiline
                        />
                        <Stack sx={{ width: "7%" }} justifyContent="right">
                          <IconButton
                            onClick={() => handleDeleteBankAcc(item.key)}
                          >
                            <RemoveCircleOutlineIcon className="close-icon" />
                          </IconButton>
                        </Stack>
                      </Stack>
                    );
                  })}
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_remark")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                  multiline
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
